import { TTypeOfCreateScheduleModalWindow } from './createScheduleModalState/createScheduleModalContext';
import { RestaurantNotificationEventType, ICreateScheduledPush } from 'types';

export enum CreateScheduleActionTypes {
	SET_PUSH_TYPE = 'SET_PUSH_TYPE',
	CHANGE_SCHEDULE = 'CHANGE_SCHEDULE',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetPushType {
	type: CreateScheduleActionTypes.SET_PUSH_TYPE;
	payload: {
		pushType: RestaurantNotificationEventType | null;
	};
}

interface IChangeSchedule {
	type: CreateScheduleActionTypes.CHANGE_SCHEDULE;
	payload: {
		schedule: string;
	};
}

interface ISetDataForSubmit {
	type: CreateScheduleActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateScheduledPush | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateScheduleActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateScheduleModalWindow;
	};
}

interface IResetSelectedControls {
	type: CreateScheduleActionTypes.RESET_FIELDS;
}

export type TCreateScheduleAction =
	| ISetPushType
	| IChangeSchedule
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
